"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const icons_1 = require("@chakra-ui/icons");
const index_1 = require("../../../index");
const backgroundColors = {
    neutral: '#F2F1EC',
    info: '#F6EEFD',
    positive: '#E1F5EB',
    caution: '#FEF1BA',
    negative: '#FFEDE6',
};
const icons = {
    neutral: react_1.default.createElement(icons_1.InfoOutlineIcon, { color: '#8A8985' }),
    info: react_1.default.createElement(icons_1.InfoOutlineIcon, { color: '#A26FE9' }),
    positive: react_1.default.createElement(icons_1.CheckIcon, { color: '#289B67' }),
    caution: react_1.default.createElement(icons_1.WarningTwoIcon, { color: '#A7850D' }),
    negative: react_1.default.createElement(icons_1.InfoOutlineIcon, { color: '#F2502B' }),
};
const Alert = ({ status = 'neutral', title, description, contained = true }) => {
    return (react_1.default.createElement(react_2.Alert, { bgColor: contained ? backgroundColors[status] : 'transparent' },
        react_1.default.createElement(react_2.HStack, { alignItems: 'top' },
            react_1.default.createElement(react_2.Box, { mt: -1 }, icons[status]),
            react_1.default.createElement(react_2.VStack, { alignItems: 'left', gap: 0 },
                title && (react_1.default.createElement(index_1.Text.Status, { appearance: status, size: 'xs', weight: 'semibold' }, title)),
                description && (react_1.default.createElement(index_1.Text.Status, { appearance: status, size: 'xs' }, description))))));
};
exports.Alert = Alert;
